import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaC_Van_Center: React.FC<AreaSVGProps> = ({
  fill = '#148B4D',
  stroke = '#148B4D',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="87"
      height="23"
      viewBox="0 0 87 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_c_van_center"
          x="0"
          y="0"
          width="87"
          height="23"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_c_van_center)">
        <path
          d="M11.75 1.12891C21.4138 4.0817 48.0816 10.5566 86 10.6689V21.9961C47.4727 21.9353 30.4664 18.3583 12.4443 14.3594C7.97089 12.8093 5.17102 11.731 1.68652 10.166C3.18523 8.6174 4.75149 7.20432 6.29688 5.87207C7.68191 4.67807 9.30466 3.33495 10.541 2.23926C10.9433 1.8827 11.3495 1.51091 11.75 1.12891Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
